module.exports = __webpack_public_path__ + "img/speed.6f3ddf5a.png";